import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.css';

const Badge = ({ tone = 'neutral', children }) => {
  const classes = [styles.badge, styles[tone]].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
};

Badge.propTypes = {
  tone: PropTypes.oneOf(['neutral', 'success', 'warning', 'danger']),
  children: PropTypes.node
};

export default Badge;
